import moment from 'moment'
import { RegionFilters } from '../util/constants'

export default {

  // Eg: 2 hours 12 minutes ago
  getTimeDifferenceWithSeconds (timestamp) {
    const timeDif = moment().diff(moment(timestamp))
    const duration = moment.duration(timeDif, 'milliseconds')
    const durationFormat = (duration < 60000) ? 's [sec]' : (duration < 3600000) ? 'm [min]' : 'h [hours] m [min]'
    const formattedDuration = moment.utc(duration.asMilliseconds()).format(durationFormat)
    return formattedDuration + ' ago'
  },
  // Eg: Few seconds ago, a minute ago (Rounded off time)
  getTimeDifference(timestamp) {
    const timeDif = moment.utc(timestamp).diff(moment.utc())
    const duration = moment.duration(timeDif, 'milliseconds').humanize(true)
    return duration
  },
  // Eg: 2 hours 3 minutes 25 seconds
  getDuration (duration) {
    const exDuration = moment.duration(duration, 'hh:mm:ss:ms').asMilliseconds()
    const durationFormat = (exDuration < 1000) ? 'SSS [ms]' : (exDuration < 60000) ? 's [sec]' : (exDuration < 3600000) ? 'm [min] s [sec]' : 'h [hours] m [min] s [sec]'
    return (exDuration === 0 ? '0 ms' : moment.utc(exDuration).format(durationFormat))
  },
  getDurationInDays(date1, date2) {
    // start = moment(moment(start).format('DD/MM/YYYY hh:mm:ss:ms'), 'DD/MM/YYYY hh:mm:ss:ms');
    // end = moment(moment(end).format('DD/MM/YYYY hh:mm:ss:ms'), 'DD/MM/YYYY hh:mm:ss:ms');

    var diffTime = Math.abs(date1 - date2);
    const diffDays = Math.ceil(diffTime  / (1000 * 60 * 60 * 24))
    //Difference in number of days
    return diffDays;
  },
  formatDateToISO(date) {
    if (date) {
      return moment(date).toISOString()
    }
  },
  // Eg: 12th Mar '21
  formatDateForLoadStatus(date) {
    if (date) {
      return moment(date).format('DD MMM \'YY')
    }
  },
  // 12 Aug 2021
  formatDatewithShortMonth(date) {
    if (date) {
      return moment(date).format('DD MMM YYYY')
    }
  },
// 27/06/2021
  formatDate(date) {
    if (date) {
      return moment(date).format('DD/MM/YYYY')
    }
  },
  // 27/06/2021 03:12 pm
  formatDateTime(date) {
    if (date) {
      return moment(date).format('DD/MM/YYYY hh:mm A')
    }
  },
  // number format to two decimal points
  formatNumberTwoDecimal(num) {
    if(num) {
      return (Math.round(num * 100) / 100).toFixed(2);
    }
  },
  // Check provide number decimal points
  validateTwoDecimalPoint(value) {
    if (value % 1 !== 0) {
      return /^\d+\.\d{0,2}$/.test(value)
    } else {
      return true
    }
  },

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), 
        n = bstr.length, 
        u8arr = new Uint8Array(n);
    
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    
    return new File([u8arr], filename, {type:mime});
  },

  getPrefixes(regions){
    var regionsPrefixes = [];
    if (regions != null && regions.length > 0){
      regions.forEach(region => {
        const prefixes = RegionFilters.filter(e => e.value == region);
        const regionPrefix = {
          'region' : region,
          'prefixes' : prefixes[0].prefixes
        }
        regionsPrefixes.push(regionPrefix);
      });
    }
    return regionsPrefixes;
  }
}
